import { Box, IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import * as React from "react";

import theme from "@/theme";

import MsinsLeadImage from "@assets/image/msins_lead.png";

import { CustomButton } from "../Button";
import { StyledModal } from "../StyledModal";

const useStyles = makeStyles(() => ({
  image: {
    width: "100%",
    height: "auto",
  },

  imageContainer: {
    position: "relative",
    width: "100%",
    height: "auto",
  },
  overlayButton: {
    position: "absolute",
    bottom: theme.spacing(3.5),
    left: "50%",
    transform: "translateX(-50%)",
    "@media (max-width:767px)": {
      bottom: theme.spacing(2),
    },
  },
  closeButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey[600],
    position: "absolute",
    top: "calc(50% - 323px)",
    right: "calc(50% - 217px)",
    width: "32px",
    height: "32px",
    zIndex: 1400,
    "&:hover": {
      backgroundColor: theme.palette.grey[500],
    },
    "@media (max-width:767px)": {
      top: "calc(50% - 279px)",
      right: "calc(50% - 188px)",
    },
  },
}));

interface MsinsLeadModalProps {
  onClose: () => void;
  onAccept: () => void;
}

export const MsinsLeadModal: React.FC<MsinsLeadModalProps> = ({ onClose, onAccept }) => {
  const classes = useStyles();

  return (
    <StyledModal onClickOutside={onClose}>
      <IconButton className={classes.closeButton} onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
      <Box className={classes.imageContainer}>
        <img src={MsinsLeadImage} alt="MsinsLead" className={classes.image} />
        <Box className={classes.overlayButton}>
          <CustomButton customVariant="filledOrangeForMsins" onClick={onAccept}>
            ZOOMによる個別面談を受けてみたい
          </CustomButton>
        </Box>
      </Box>
    </StyledModal>
  );
};
